export default "__VITE_ASSET__Na83yxcT__"